//-- Copyright (c) 2021 TMT Insights Group, LLC
import {
  DateTimeDisplay,
  FileTypeDisplay,
  PolarisIcon,
  IngestManagementOverflowMenu,
  IngestManagementPreview,
  ActionableTableStatus,
  IngestManagementRowExpand
} from '@tmt-insights/oms_fe_core/columns';
import { Grid } from '@tmt-insights/oms_fe_core/material';
import { formatBytes } from '@tmt-insights/oms_fe_core/utils';
import { IngestFile } from '@/redux/slices/slice_types';
import { AllTableColumnsConfig } from '@tmt-insights/oms_fe_core';

const columns: AllTableColumnsConfig<IngestFile> = {
  expandable: {
    label: '',
    isExpandable: true,
    render: (row: IngestFile, frozenRightWidth: number) => <IngestManagementRowExpand data={row} previewWidth={frozenRightWidth} />
  },
  hid: {
    label: 'ID',
    sortField: 'id',
    position: 'left',
    width: 100,
    render: (cell: IngestFile['hid']) => <strong style={{ color: 'var(--primary-main)' }}>{cell}</strong>
  },
  created_at: {
    label: 'Created',
    position: 'left',
    sortField: 'created_at',
    render: (cell: IngestFile['created_at']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  },
  filename: {
    label: 'File Name',
    flex: 4
  },
  file_type: {
    label: 'File Type',
    minWidth: 130,
    disableSort: true,
    render: (cell: IngestFile['file_type']) => <FileTypeDisplay type={cell} />
  },
  file_size: {
    label: 'File Size',
    disableSort: true,
    minWidth: 120,
    render: (cell: IngestFile['file_size']) => {
      return cell ? (
        <Grid container alignItems="center">
          <PolarisIcon icon="clarity:hard-disk-solid" height={20} style={{ marginRight: 5, opacity: 0.6 }} />
          {formatBytes(cell)}
        </Grid>
      ) : (
        '-'
      );
    }
  },
  version_id: {
    label: 'Version ID',
    disableSort: true,
    render: (cell: IngestFile['version_id']) => {
      return cell ? cell : '-';
    }
  },
  episode_name: {
    label: 'Episode',
    flex: 4
  },
  season_number: {
    label: 'Season'
  },
  series_name: {
    label: 'Series',
    flex: 4
  },
  preview: {
    label: 'Preview',
    position: 'right',
    disableSort: true,
    width: 110,
    render: (_: undefined, row: IngestFile, expanded: boolean, previewDimensions: { width?: number; height?: number }) => {
      return (
        <IngestManagementPreview
          data={row}
          expanded={expanded}
          previewDimensions={{ width: previewDimensions?.width || 0, height: previewDimensions?.height || 0 }}
        />
      );
    }
  },
  stage: {
    label: 'Status/Stage',
    width: 220,
    render: (cell: string, row: IngestFile) => <ActionableTableStatus status={cell} row={row} />,
    position: 'right',
    disableSort: false
  },
  overflow: {
    label: '',
    position: 'right',
    width: 120,
    disableSort: true,
    render: (cell: IngestFile, row: IngestFile) => <IngestManagementOverflowMenu data={row} />
  }
};

export default columns;
